<template>
    <div class="hpo-patient-modal-section">
        <div class="hpo-patient-modal-section__head">
            <div class="hpo-patient-modal-section__head__title-row">
                <h3 v-if="title">{{ title }}</h3>
            </div>
        </div>
        <div class="hpo-patient-modal-section__body">
            <slot name="body"></slot>
        </div>
    </div>
</template>

<script>

export default {
    name: 'HpoPatientModalSection',
    props: {
        title: {
            type: String,
            required: false
        },
    },
}

</script>

